import { qs, qsa, toggle, remove } from "@fluorescent/dom";
import { simpleParallax } from "simple-parallax-js";
import { section } from "@/glow";
import { on, emit } from "@/glow/events";
import navigationDots from "@/lib/navigation-dots";

section("slideshow", {
  listeners: [],
  onLoad() {
    const { autoplay, parallaxScale, enableParallax } = this.container.dataset;
    const sliderEl = qs(".js-slideshow", this.container);
    const images = qsa(".responsive-image__image", this.container);

    let dotNavigation = null;

    remove(this.container, "hidden");

    import(flu.chunks.flickity).then(({ Flickity }) => {
      this.slideshow = new Flickity(sliderEl, {
        autoPlay: parseInt(autoplay, 10),
        prevNextButtons: false,
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true,
        on: {
          ready: () => {
            toggle(
              sliderEl,
              "is-single",
              qsa(".slideshow__slide", sliderEl).length <= 1
            );
            this.parallaxElements &&
              this.parallaxElements.forEach(el => el.refresh());
          },
        },
      });

      setTimeout(() => {
        this.slideshow.resize();
      }, 500);

      if (qs(".navigation-dots", this.container)) {
        dotNavigation = navigationDots(this.container, this.slideshow);

        this.slideshow.on("select", () => {
          dotNavigation.update(this.slideshow.selectedIndex);
        });
      }
    });

    if (enableParallax === "true") {
      this.parallaxElements = images.map(image => {
        return new simpleParallax(image, {
          scale: parallaxScale,
        });
      });
    }
  },

  handleBlockSelect(slideIndex) {
    this.slideshow.pausePlayer();
    this.slideshow.select(slideIndex);
  },

  onUnload() {
    this.slideshow && this.slideshow.destroy();
    this.parallaxElements &&
      this.parallaxElements.forEach(element => element.destroy());
  },

  onSelect() {
    emit("transparentSectionUpdate");
  },

  onBlockSelect({ target }) {
    if (this.slideshow) {
      this.handleBlockSelect(target.dataset.index);
    } else {
      // Listen for initalization if slideshow does not exist
      this.listeners.push(
        on("slideshow:initialized", () => {
          this.handleBlockSelect(target.dataset.index);
        })
      );
    }
  },

  onBlockDeselect() {
    if (this.slideshow) {
      this.slideshow.unpausePlayer();
    } else {
      // Listen for initalization if slideshow does not exist
      this.listeners.push(
        on("slideshow:initialized", () => {
          this.slideshow.unpausePlayer();
        })
      );
    }
  },
});
